import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-image: ${(props) => `url(${props.backgroundImage})`};
  border-radius: 5px;
  padding: 20px;
  color: #fff;
  margin: 20px 0px;
`;

export const Title = styled.div`
  font-size: 20px;
  font-weight: normal;
  font-family: "Avenir Next LT W01 Demi";
  line-height: 1.3;
`;

export const GoalcardCard = styled.img`
  max-width: 100%;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3)
`;

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  color: #fff;
  font: normal 30px/27px "Avenir Next LT W01 Demi";
  margin-top: 15px;
`;

export const InformationDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 4;
  font-size: 15px;
  font-weight: 500;
`;

export const DetailLabel = styled.div`
`;

export const Amount = styled.div`
  flex-grow: 1;
  text-align: center;
  align-self: center;
`;
